import React from 'react';
import { useParams } from 'react-router-dom';
import PlaceholderPage from './PlaceholderPage';

const LedgerDetailPage: React.FC = () => {
  const { shipmentId } = useParams<{ shipmentId: string }>();
  return (
    <PlaceholderPage
      title="应收应付详情"
      summary={`运单 ${shipmentId || '—'} 的应收/应付明细占位；后续展示核对与改价入口。`}
      designSection="对账详情 / kac-003+"
    />
  );
};

export default LedgerDetailPage;
